

    import {Options, prop, Vue} from 'vue-class-component';
    import {toClipboard} from '@soerenmartius/vue3-clipboard';
    import {recordingFile} from "@/util";
    import QrcodeVue from 'qrcode.vue'

    class Props {
        id: string = prop({
            required: true,
        });
        recordingInfo: any = prop({
          required: false,
        });
    }

    @Options({components: {QrcodeVue}})
    export default class ShareRecording extends Vue.with(Props) {

        id!: string;

        url: string = '';
        downloadUrl: string = '';

        actionDetails: string = 'none';

        embedCode: string = '';

        created() {
            this.url = `${window.location.protocol}//${window.location.host}/${this.id}`;
            this.downloadUrl = recordingFile(this.id);
            this.embedCode = this.createEmbedCode();
        }

        copyUrl() {
            toClipboard(this.url);
            // @ts-ignore
            const input: HTMLInputElement = this.$refs['input'];
            input.focus();
            input.select();
        }

        copyEmbedCode() {
            toClipboard(this.embedCode);
            // @ts-ignore
            const textarea: HTMLInputElement = this.$refs['embed'];
            textarea.focus();
            textarea.select();
        }

        createEmbedCode(): string {
            const embedUrl = `${window.location.protocol}//${window.location.host}/embed.html#${this.id}`;
            return `<div><iframe width="300" height="60" src="${embedUrl}" frameborder="0" allow="autoplay"></iframe><br><a href="${this.url}" title="RecArena" target="_blank">Auf RecArena anhören</a></div>`;
        }

        $refs!: {
          qrcode: HTMLElement;
        };

        downloadQrCode() {
          const canvas = this.$refs.qrcode.getElementsByTagName('canvas')[0];
          if (!canvas) {
            console.error('No canvas found for QR code.');
            return;
          }

          const borderSize = 20;
          const borderedCanvas = document.createElement('canvas');
          borderedCanvas.width = canvas.width + borderSize * 2;
          borderedCanvas.height = canvas.height + borderSize * 2;

          const ctx = borderedCanvas.getContext('2d');
          if (!ctx) {
            console.error('No bordered canvas found for QR code.');
            return;
          }
          ctx.fillStyle = 'white';
          ctx.fillRect(0, 0, borderedCanvas.width, borderedCanvas.height);
          ctx.drawImage(canvas, borderSize, borderSize);

          borderedCanvas.toBlob((blob) => {
            const a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = 'qrcode_recarena.png';
            document.body.appendChild(a);
            a.click();
            a.remove();
          }, 'image/png');
        }
    }
